import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';

type StudbookContextStore = {
  orgId: string;
  setOrgId: (orgId: string) => void;
  clearOrgId: () => void;
};

const useStudbookContext = create<StudbookContextStore>()(
  persist(
    devtools(
      immer((set) => ({
        orgId: '',
        setOrgId: (orgId) =>
          set((state) => ({
            orgId,
          })),
        clearOrgId: () =>
          set((state) => ({
            orgId: '',
          })),
      })),
      { name: 'StudbookContextStore' },
    ),
    {
      name: 'StudbookContextStore',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useStudbookContext;
